import { useTranslation } from 'next-i18next'

import { fr } from '@front/locales'
import type { Locale } from '@hublo/common/translation'

const localeToNationalityKey: Record<Locale, string> = {
  fr: 'french',
  en: 'english',
  de: 'german',
  es: 'spanish',
}

export const useNationalityIndexFromLanguage = () => {
  const { i18n } = useTranslation()

  const index = Object.keys(fr.mainNationality).findIndex(
    (key) => key === localeToNationalityKey[i18n.language as Locale],
  )

  if (index !== -1) {
    return index
  }

  return undefined
}
